/* global axios */
import ApiClient from './ApiClient';

class EvolutionInstances extends ApiClient {
  constructor() {
    super('evolution_instances', { accountScoped: true });
  }

  connect(inboxId) {
    return axios.get(`${this.url}/${inboxId}/connect`);
  }

  status(inboxId) {
    return axios.get(`${this.url}/${inboxId}/status`);
  }

  disconnect(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/disconnect`);
  }
}

export default new EvolutionInstances();
